import {getApp,getApps,initializeApp}from "firebase/app"
import {getFirestore } from "firebase/firestore"
import {getStorage} from "firebase/storage"
const firebaseConfig = {
    apiKey: "AIzaSyCmJY-zQ3fQWnDDHm2NJ8vbLqW04sGx_m0",
    authDomain: "fishfarming-80d6d.firebaseapp.com",
    databaseURL: "https://fishfarming-80d6d-default-rtdb.firebaseio.com",
    projectId: "fishfarming-80d6d",
    storageBucket: "fishfarming-80d6d.appspot.com",
    messagingSenderId: "211834983264",
    appId: "1:211834983264:web:8a9b472906b468f6f2c405",
    measurementId: "G-KVC38VS2YY"
  };

  const app = getApps.length> 0 ? getApp() : initializeApp(firebaseConfig);
  const firestore =getFirestore(app)
  const storage = getStorage(app)
  export{ app ,firestore , storage}